/* global getCookie setCookie deleteCookie ga fbq Base64 */
var timer;
$(document).ready(function () {
  // StartEmarsysLoading
  $(".slim-trim-title").click(function () {
    if (!$(this).parent().hasClass('active')) {
      $('.content-1').toggleClass('active');
      $('.content-2').toggleClass('active');
    }
  });
  $(".trim-slim-ingredient-toggle").click(function () {
    $(this).parent().toggleClass('active');
    $(this).parent().parent().find('.ingredient-more').toggleClass('active');
  });
  $(".elixir-ingredient-toggle").click(function () {
    $(this).parent().toggleClass('active');
    $(this).parent().parent().find('.ingredient-more').toggleClass('active');
  });
  $('.all-ingredients.see-more a').click(function () {
    $(this).parent().toggleClass('active');
    $(this).parent().find('p').toggle();
  });

  if ($(".tips-banner-slider").length > 0) {
    $(".tips-banner-slider").slick({
      dots: true,
      arrow: false,
      arrows: !1,
      prevArrow: "<span class=\"slick-arrow-custom slick-prev-arrow\"><svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#global__symbols-left-arrow\"></use></svg></span>",
      nextArrow: "<span class=\"slick-arrow-custom slick-next-arrow\"><svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#global__symbols-right-arrow\"></use></svg></span>",
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToScroll: 1,
          arrow: true
        }
      }]
    });
  }

  $('.slim-trim-btn').click(function () {
    $('div[data-subscribe-variant-id=31546293223460]').click();
    setTimeout(function () {
      $('.on-page.button.button-cart').trigger('click');
      return false;
    }, 500);
    return false;
  });
  $('.nutri-quick-buy').click(function (e) {
    e.preventDefault();
    $('.product-form').find('button').click();
  });
  $('.hgb-btn').click(function () {
    $(this).text('Adding...');
    setTimeout(function () {
      $('.hgb-btn').text('ADD TO CART');
    }, 3500);
    setTimeout(function () {
      $('#AddToCart-product-hbg-template').trigger('click');
      return false;
    }, 500);
    return false;
  });
  var priceEl = $('.price-save');

  if (priceEl.length) {
    priceEl.each(function (i, el) {
      var price_new = $(el).attr('data-price-new');
      var price_old = $(el).attr('data-price-old');
      var percentage = (price_old - price_new) / price_old * 100;
      $(el).find('span.money').text("(SAVE ".concat(percentage.toFixed(), "%)"));
    });
  }

  if ($('.mixmatch-related').length > 0) {
    var mixmatchSlide = $('.mixmatch-related');
    mixmatchSlide.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: true,
      adaptiveHeight: !0,
      prevArrow: "<span class=\"slick-arrow-custom slick-prev-arrow\"><svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\"><defs><style>.aar{fill:#f56994;}</style></defs><path class=\"arr\" d=\"M13.378,20.322,5.129,11.989l8.249-8.333a2.154,2.154,0,0,0,0-3.028,2.1,2.1,0,0,0-3,0L.622,10.486a2.154,2.154,0,0,0,0,3.028l9.759,9.858a2.1,2.1,0,0,0,3,0,2.2,2.2,0,0,0,0-3.05Z\"/></svg></span>",
      nextArrow: "<span class=\"slick-arrow-custom slick-next-arrow\"><svg width=\"14\" height=\"24\" viewBox=\"0 0 14 24\"><defs><style>.arr{fill:#f56994;}</style></defs><path class=\"arr\" d=\"M13.378,20.322,5.129,11.989l8.249-8.333a2.154,2.154,0,0,0,0-3.028,2.1,2.1,0,0,0-3,0L.622,10.486a2.154,2.154,0,0,0,0,3.028l9.759,9.858a2.1,2.1,0,0,0,3,0,2.2,2.2,0,0,0,0-3.05Z\" transform=\"translate(14 24) rotate(180)\"/></svg></span>",
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: "".concat(0, "px"),
          arrows: true
        }
      }]
    });
    mixmatchSlide.find('.slick-dots button').append("<svg  width=\"15.667\" height=\"13\" viewBox=\"0 0 15.667 13\"><defs><style>.act{fill:#ffffff;}</style></defs><path class=\"act\" d=\"M955.68,942.47a4.316,4.316,0,0,0-6,0l-.587.574-.516-.5a4.385,4.385,0,0,0-5.963-.175,4.08,4.08,0,0,0-.112,5.968l5.69,5.558a1.3,1.3,0,0,0,1.8,0l5.689-5.558A4.078,4.078,0,0,0,955.68,942.47Z\" transform=\"translate(-941.256 -941.256)\"/></svg>");
  }

  setTimeout(function () {
    $('.m-loading').hide();
    $('.related-mix-match .mixmatch-related').css('visibility', 'visible');
  }, 500);
});
$('div[data-bg]').each(function () {
  var bg = $(this).attr('data-bg');
  $(this).css('backgroundImage', "url('".concat(bg, "')"));
});
$('.big-image img').each(function () {
  if (!$(this).attr('src')) {
    $(this).attr('src', $(this).attr('data-src'));
  }
});

if (window.currentTemplate === 'product.green-cleansing-elixir') {
  if (window.screen.width < 767) {
    var di = $('.elixir-body.mobile');
    var bg = di.data('background');
    di.css('backgroundImage', "url('".concat(bg, "')"));
  }

  $('.yotpo .promoted-products-box img').attr('src', '');
}

if ($('#notice-bar-content').length > 0) {
  $(document).ready(function () {
    window.getUtcTime = function (date) {
      var now = new Date(date);
      var utc_timestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
      return utc_timestamp - 8 * 60 * 60 * 1000;
    };

    window.nowUtcTime = function () {
      var now = new Date();
      var utc_timestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
      return utc_timestamp;
    };

    window.startCount = function (endAt, startAt, counterDuration) {
      var start = new Date(getUtcTime(startAt));
      var end = new Date(getUtcTime(endAt));

      function showRemainingCountdown() {
        var now = new Date();
        var distance = new Date(getUtcTime(endAt)) - now; //let distanceWhole = new Date(getUtcTime(endAt)) - start;

        var distanceWhole = end - start;

        if (counterDuration > 0) {
          distanceWhole = new Date(endAt) - start;
          distanceWhole = counterDuration * 60000;
          distance = new Date(endAt) - now;
        } // console.log('rem', distance)


        if (distance < 0) {
          clearInterval(timer); //document.getElementById('notice-bar-content').innerHTML = 'EXPIRED!';

          $('.distance').css('width', '100%');
          $('.distance-exit-intent').css('width', '100%');
          $('.countdown-bar').remove();
          $('.cart-countdown').remove();
          $('div.mega-menu-type-2').css('top', 48);
          $('#header--main-content.fixed').css('top', 0);
          return;
        }

        var days = Math.floor(distance / _day);
        var hours = Math.floor(distance % _day / _hour);
        var minutes = Math.floor(distance % _hour / _minute);
        var seconds = Math.floor(distance % _minute / _second);
        var minutesLeft = Math.floor(distance / 1000);
        var minutesTotal = Math.floor(distanceWhole / 1000);
        $('.numdaysn').html(days);

        if (days > 1) {
          $('.numdaysninfo').html('DAYS');
        } else {
          $('.numdaysninfo').html('DAY');
        }

        $('.numhoursn').html(hours);

        if (hours > 1) {
          $('.numhoursninfo').html('HRS');
        } else {
          $('.numhoursninfo').html('HR');
        }

        $('.numminsn').html(minutes);

        if (minutes > 1) {
          $('.numminsninfo').html('MINS');
        } else {
          $('.numminsninfo').html('MIN');
        }

        $('.numsecsn').html(seconds);

        if (seconds > 1) {
          $('.numsecsninfo').html('SECS');
        } else {
          $('.numsecsninfo').html('SEC');
        }

        var progressNum = (minutesTotal - minutesLeft) / minutesTotal * 100;
        var bar_proggress = Math.round((progressNum + Number.EPSILON) * 100) / 100;

        if (counterDuration > 0) {
          bar_proggress = distance / 1000000000 * 100;
          bar_proggress = 100 - distance / distanceWhole * 100;
        }

        $('.distance').css('width', "".concat(bar_proggress, "%"));
        $('.distance-exit-intent').css({
          'width': "".concat(bar_proggress, "%"),
          'background-color': '#FF6EA9'
        });
      }

      if (counterDuration > 0) {
        end = new Date(new Date().getTime() + counterDuration * 60000);
      }

      var _second = 1000;

      var _minute = _second * 60;

      var _hour = _minute * 60;

      var _day = _hour * 24;

      timer = setInterval(showRemainingCountdown, 1000);
    };

    var startAt = getUtcTime("".concat('2022-02-14 00:00:00'.replace(' ', 'T'), "Z"));
    var endAt = getUtcTime("".concat('2022-02-15 13:00:00'.replace(' ', 'T'), "Z"));
    var nowTime = nowUtcTime();

    if (parseInt('') > 0 && getCookie('_counter_expired_at') !== '' && getCookie('_counter_expired_at') !== null && getCookie('_counter_start_at') !== '' && getCookie('_counter_start_at') !== null && typeof timer === 'undefined') {
      startCount(getCookie('_counter_expired_at'), parseInt(getCookie('_counter_start_at')), parseInt(''));
    } else if (nowTime > startAt && nowTime < endAt) {
      window.startCount("".concat('2022-02-15 13:00:00'.replace(' ', 'T'), "Z"), "".concat('2022-02-14 00:00:00'.replace(' ', 'T'), "Z"), 0);
    } else {
      console.log('expired1');
      $('.cart-countdown').addClass('hide-default');
      $('.countdown-bar').addClass('hide-default');
    }
  });
}

if ($('.product-naration.fullwidth').length > 0) {
  $(document).ready(function () {
    var a = $('.product-naration.fullwidth').parent();
    var offset = $(a).offset();
    $(a).css({
      width: window.innerWidth,
      left: "-".concat(offset.left, "px"),
      marginTop: 50
    });
    $(a).addClass('fullwitdh-background');
    $(window).resize(function () {
      var el = $('.product-naration.fullwidth').parent();
      el.width($('body').width());
      el.css('left', '0px');
      var width = el.width();
      var T = el.offset();
      el.css('position', 'relative');
      $(el).css({
        width: width,
        left: "-".concat(T.left, "px")
      });
    });
  });
} // signup popup


var Base64 = {
  decode: function decode(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  },
  encode: function encode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
  }
}; //time last visited

function checkPastVisited() {
  var d = new Date();

  if (!getCookie('_bc_last_visited')) {
    setCookie('_bc_last_visited', d.getTime(), 365);
  } else {
    var lastVisit = getCookie('_bc_new_visit');
    setCookie('_bc_last_visited', lastVisit);
  }

  setCookie('_bc_new_visit', d.getTime(), 365);
}

function treatAsUTC(date) {
  var result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
}

function daysBetween(startDate, endDate) {
  var millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
}

try {
  if (!getCookie('_shopify_country') || !getCookie('_shopify_country_code')) {
    var xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        resp = JSON.parse(xhttp.responseText);
        currentCountryName = resp.country_name;
        setCookie("_shopify_country", resp.country_name, 0.04);
        setCookie("_shopify_country_code", resp.country_code2);
        setCookie("_shopify_country_region_name", resp.region_name);
      }
    };

    xhttp.open("GET", "".concat(window.apiEndpoint, "/geo"), true);
    xhttp.send();
  }

  if (getCookie("bluecore_email_address")) {
    var bluecore_email_address = Base64.decode(getCookie("bluecore_email_address"));
  } // if (!localStorage.getItem('bluecore_show_modal')) {
  //   if (document.body.classList.contains('template-index') || document.body.classList.contains('template-blog')) {
  //     localStorage.setItem('bluecore_show_modal', 'show');
  //   } else {
  //     localStorage.setItem('bluecore_show_modal', 'hide');
  //   }
  // }

} catch (err) {
  console.log(err);
}

checkPastVisited(); //check from API

function checkEmailSignUp() {
  var isAlreadySignedUp = false;

  if (getCookie("bluecore_email_address")) {
    var bemail = Base64.decode(getCookie("bluecore_email_address"));
    var xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        resp = JSON.parse(xhttp.responseText);

        if (resp.status == 'registered') {
          isAlreadySignedUp = true;
        }

        return isAlreadySignedUp;
      }
    };

    xhttp.open("GET", "".concat(window.apiEndpoint, "/bluecore/check?email=").concat(bemail, "&domain=").concat(window.location.hostname), true);
    xhttp.send();
  }

  return isAlreadySignedUp;
}

var checkEmailSignup = checkEmailSignUp();

if (!checkEmailSignup && localStorage.getItem('bluecore_show_modal') == 'show') {
  localStorage.setItem('bluecore_show_modal', 'show');
}

var oldVisitDate = parseInt(getCookie('_bc_last_visited'));
var newVisitDate = parseInt(getCookie('_bc_new_visit'));
var daysDifference = daysBetween(oldVisitDate, newVisitDate);

if (daysDifference > 7 && !checkEmailSignup && localStorage.getItem('bluecore_show_modal') == 'show') {
  localStorage.setItem('bluecore_show_modal', 'show');
}

var newSignup = document.getElementsByClassName('tiny_signup'); // METHOD FOR SIGNUP

var currentCountryName = ''; // SET COUNTRY NAME

if (getCookie('signup_popup') != null && getCookie('signup_popup') != '') {
  hideByClassName('popup-email--show');
  hideByClassName('large-newsletter-popup'); // hideByClassName('newsletter-overlay');

  checkHelpButton();
} else {
  $(".popup-email--hide").removeClass("popup-email--hide").addClass("popup-email--show");
  q = document.querySelector('.desktop-d');

  if (q) {
    q.className = q.className.replace("desktop-d", "");
  }

  setTimeout(function () {
    if (newSignup.length > 0 && window.getComputedStyle(newSignup[0]).display !== 'none') {
      if (document.getElementById('btt-button')) {
        document.getElementById('btt-button').classList.add('show--popup');
      }
    }
  }, 1000);
  var zeLauncherInterval = setInterval(function () {
    if (document.getElementById('launcher')) {
      setTimeout(function () {
        /** variant test */
        if (newSignup.length > 0 && window.getComputedStyle(newSignup[0]).display !== 'none') {
          document.getElementById('launcher').style.setProperty('bottom', '130px', 'important');
        }
      }, 2000);
      clearInterval(zeLauncherInterval);
    }
  }, 500);
}

currentCountryName = getCookie('_shopify_country');
country_name = document.getElementById("footer-country-name");
popup_country_name = document.getElementById("popup-country-name");

if (country_name != null) {
  country_name.value = currentCountryName;
}

if (popup_country_name != null) {
  popup_country_name.value = currentCountryName;
}

var smsbumpids = {
  "skinny-mint-us.myshopify.com": 32122,
  "skinny-mint.myshopify.com": 32124,
  // dev environtment use CA id
  "skinny-mint-au.myshopify.com": 32123,
  "skinny-mint-ca.myshopify.com": 32124,
  "skinny-mint-sg.myshopify.com": 32127
};

var validate_email_and_send = function validate_email_and_send(event) {
  var email = document.getElementById("signupnl-popup-variant").value;
  var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var phoneNum = document.getElementById("signup_popup_phone").value;
  var phoneValid = phoneNum != '' && window.validatePhone(phoneNum);
  var phoneCountry = document.getElementById('popup_select_country').value; //let smsBumpId = smsbumpids[Shopify.shop];

  var smsBumpId = document.getElementById('signup_popup_phone').getAttribute('data-smsbump-id');

  if (filter.test(email) || phoneValid) {
    if (typeof fbq === 'function') {
      fbq('track', 'Lead');
    }

    var phonePrefix = $('#popup_country_code').text().trim();

    if (phonePrefix != '' && phoneNum != '') {
      phoneNum = phonePrefix + phoneNum;
    }

    push_cust_email_to_signupnl(email, 'signup-popup', "".concat(window.apiEndpoint, "/bluecore/registrations"), event, phoneNum);

    if (phoneValid && phoneCountry != '') {
      submitPhoneBump(phoneCountry, document.getElementById("signup_popup_phone").value, parseInt(smsBumpId));
    }
  } else {
    alert("Please Enter valid email or phone number");
  }
};

var validate_email_and_send_large = function validate_email_and_send_large(event) {
  var tnc = $('#tnc_newsletter');
  var email = document.getElementById("signupnl-popup-variant-large").value;
  var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var phoneNum = document.getElementById("signup_popup_phone_large").value.replace(/^0+/, '');
  var phoneValid = phoneNum != '' && window.validatePhone(phoneNum);
  var phoneCountry = document.getElementById('popup_select_country').value; //let smsBumpId = smsbumpids[Shopify.shop];

  var smsBumpId = document.getElementById('signup_popup_phone_large').getAttribute('data-smsbump-id');

  if ((filter.test(email) || phoneValid) && tnc.is(':checked')) {
    if (typeof fbq === 'function') {
      fbq('track', 'Lead');
    }

    var phonePrefix = $('#popup_country_code').text().trim();

    if (phonePrefix != '' && phoneNum != '') {
      phoneNum = phonePrefix + phoneNum;
    }

    push_cust_email_to_signupnl(email, 'signup-popup', "".concat(window.apiEndpoint, "/bluecore/registrations"), event, phoneNum);
    klaviyo_call(email,phoneNum);
    
    if (phoneValid && phoneCountry != '') {
      submitPhoneBump(phoneCountry, phoneNum, parseInt(smsBumpId));
    }
  } else if (!tnc.is(':checked')) {
    alert("You have not agreed to the Privacy Policy & ToS");
  } else {
    alert("Please Enter valid email or phone number");
  }
};

var validate_email_and_push_email = function validate_email_and_push_email(event) {
  var email = document.getElementById("signup-footer").value;
  var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (filter.test(email)) {
    if (typeof fbq === 'function') {
      fbq('track', 'Lead');
    }

    push_cust_email_to_signupnl(email, 'signup-footer', "".concat(window.apiEndpoint, "/bluecore/registrations"), event, '');
    klaviyo_call(email);
    
  } else {
    alert("Please Enter valid email");
  }
};

var push_cust_email_to_signupnl = function push_cust_email_to_signupnl(email, tag, url, event, phone) {
  var url = url;
  ajaxRequest = new XMLHttpRequest();
  ajaxRequest.open("POST", url, true);
  ajaxRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  var signature = encryptParam("{email:'".concat(email, "',time:").concat(new Date().getTime(), "}"));

  if (tag === "signup-popup") {
    ajaxRequest.send("signature=" + signature + "&email=" + email + "&country=" + currentCountryName + "&brand_name=" + 'skinnymint' + "&reg_source=" + 'popup' + "&brand=" + 'skinnymint' + "&phone=" + phone);
    $("#popup-newsletter").removeClass("hide");
    $(".popup-email--form").hide();
    $('.newsletter-bottom, .large-newsletter-popup__bottom').hide();
    $(".popup-email--thankyou, .large-newsletter-popup__thankyou").show();
    $('.popup-email.tiny_signup .js-close').css({
      'display': 'flex'
    });
    $('.popup-email.tiny_signup .phone-close').hide();
    setCookie('signup_popup', 'signup_popup', 30);
    setCTA();
    utmParams();
    ga('send', 'event', 'PopupSignup', 'NewsletterPopupSignup', '');
  } else {
    ajaxRequest.send("signature=" + signature + "&email=" + email + "&country=" + currentCountryName + "&brand_name=" + 'skinnymint' + "&reg_source=" + 'footer');
    $("#success-message").remove();
    $(".signup-footer").append("<span id='success-message' style='margin-top:10px; display: table;padding: 0px;font-size: 16px;margin-bottom: 6px;background-color: transparent;color: #fff;line-height:normal;'>Yay, thanks for subscribing 🌟</span>");
    document.getElementById("signup-footer-form").reset(); // flush footer email

    setTimeout(function () {
      $("#success-message").remove();
    }, 5000);
  }

  setCookie("bluecore_email_address", Base64.encode(email), 365);
  return false;
};

var klaviyo_call = function(Email,phoneNumber){
  const options = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      "store": "au",
      "email": Email,
      "phone": phoneNumber
    })
  };
    
  fetch('https://skinnymint-php.herokuapp.com/', options)
  .then(response => response.json())
  .then(response => console.log(response))
  .catch(err => console.log(err));
}

popup_close_event = document.getElementById("popup-close");

if (popup_close_event != null) {
  popup_close_event.addEventListener("click", popupClose);
}

function popupClose() {
  setCookie('signup_popup', 'signup_popup', 30);
  setCTA();
  hideByClassName('popup-email--show');
  hideByClassName('large-newsletter-popup');
  hideByClassName('newsletter-overlay');
  checkHelpButton();
  var launcher = document.getElementById('launcher');

  if (launcher && window.innerWidth < 768) {
    launcher.style.setProperty('right', '0px', 'important');
    launcher.style.setProperty('bottom', '60px', 'important');
  }
} // AB TEST SCRIPT


$(document).ready(function () {
  if ($('.large-newsletter-popup').hasClass('popup--delay-after-load')) {
    setTimeout(function () {
      $('.large-newsletter-popup').removeClass("popup--delay-after-load").addClass("popup-email--show");

      if (window.innerWidth < 769 && window.location.href.includes('products') && getCookie('signup_popup') != 'signup_popup') {
        var startPopupTimer = function startPopupTimer() {
          console.log('p start');
          $('#signupnl-popup-variant-large').on('keyup', function () {
            console.log('p keyup');
            clearTimeout(nsTimeout);
          });
          var nsTimeout = setTimeout(function () {
            popupClose();
          }, 10000);
        };

        console.log('p mobile');
        var nsTimeout;
        startPopupTimer();
      }
    }, 2000);
  }
}); ///////

function submitPhoneBump(country, phone, formId) {
  var phoneData = JSON.stringify({
    country: country,
    phone: phone,
    email: '',
    form_id: formId
  });
  $.ajax({
    url: 'https://api.smsbump.com/v2/formsPublic/subscribe',
    method: 'POST',
    cache: false,
    data: phoneData,
    contentType: 'application/json; charset=utf-8',
    headers: {
      'X-SMSBump-Platform': 'shopify'
    },
    success: function success(res) {
      if (res.message) {
        console.log(res.message);
      } else {
        console.log('smsbumperror');
      }
    }
  });
}

;

function utmParams(utm_campaign_name) {
  var loc = window.location.hostname.split('.')[0];
  var store = loc === 'www' || loc === 'dev' ? 'us' : loc;
  store = store === 'de' ? 'eu' : store;

  if (utm_campaign_name) {
    var utmname = utm_campaign_name;
  } else {
    var utmname = 'popup_signup_submit_' + store;
  }

  locations = window.location.href.split("?");
  query = "";

  if (locations.length > 1) {
    query = locations[1];
  }

  new_query = [];
  utm_found = false;
  query.split("&").forEach(function (value, index) {
    v = value.split("=");

    if (v[0] == 'utm_source') {
      utm_found = true;
      new_query.push(["utm_source=supopup"]);
    } else if (v[0] == 'utm_medium') {
      utm_found = true;
      new_query.push("utm_medium=display");
    } else if (v[0] == 'utm_campaign') {
      utm_found = true;
      new_query.push("utm_campaign=" + utmname);
    } else {
      new_query.push(v.join("="));
    }
  });
  string_query = new_query.join("&");

  if (!utm_found) {
    if (string_query) {
      string_query += '&utm_source=supopup&utm_medium=display&utm_campaign=' + utmname;
    } else {
      string_query += 'utm_source=supopup&utm_medium=display&utm_campaign=' + utmname;
    }
  }

  nurl = window.location.pathname + "?" + string_query;
  window.history.pushState({
    href: nurl
  }, '', nurl);
  ga('send', 'pageview', nurl);
} // [FIXME] initializd popup class and make method to close that popup by clicking close icon


var popup_close = document.getElementsByClassName('js-close');

for (var i = 0; i < popup_close.length; i++) {
  popup_close[i].onclick = function () {
    popupClose();
  };
} // action perform on submit of signup popup


function signupPopup_small() {
  validate_email_and_send();
  return false;
}

;

function signupPopup_large() {
  validate_email_and_send_large();
  return false;
}

; // hide class by passing class name on this

function hideByClassName(classname) {
  var divsToHide = document.getElementsByClassName(classname); //divsToHide is an array

  for (var i = 0; i < divsToHide.length; i++) {
    divsToHide[i].style.visibility = "hidden"; // or

    divsToHide[i].style.display = "none"; // depending on what you're doing
  }
}

function checkHelpButton() {
  if (document.getElementById('btt-button')) {
    document.getElementById('btt-button').classList.remove('show--popup');
  }

  if (document.getElementById('launcher')) {
    document.getElementById('launcher').style.setProperty('bottom', '0px', 'important');
  }
} // make this to fix safari popup download issue - so if you change anything on this plz test in safari


var footer = document.getElementById("signup-footer-form");

if (footer) {
  footer.onsubmit = function (event) {
    validate_email_and_push_email();
    event.preventDefault();
  };
}

var popup_form = document.getElementById("signup-popup-tag");

if (popup_form) {
  popup_form.onsubmit = function (event) {
    event.preventDefault();
  };
}

function setCTA() {
  q = document.querySelector('button.add-to-cart');

  if (q) {
    if (q.className.indexOf('desktop-d') == -1) {
      q.className = q.className + " desktop-d";
    }
  }
}

function addEvent(obj, evt, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent("on" + evt, fn);
  }
}

addEvent(window, "load", function (e) {
  var intervalOptIn = setInterval(function () {
    if (document.getElementsByClassName('pushowl-optin').length > 0) {
      document.getElementsByClassName('pushowl-optin')[0].classList.add('pushowl-optin-hide');
      clearInterval(intervalOptIn);
    }
  }, 500);
  addEvent(document, "mouseout", function (e) {
    e = e ? e : window.event;
    var from = e.relatedTarget || e.toElement;

    if (!from || from.nodeName == "HTML") {
      //var newsletterOverlay = document.getElementById('popup_newsletter');
      if (document.getElementsByClassName('pushowl-optin').length > 0) {
        var pushOwlOptin = document.getElementsByClassName('pushowl-optin')[0];
        pushOwlOptin.classList.remove('pushowl-optin-hide');
        pushOwlOptin.setAttribute('style', 'display:block !important');
      }
    }
  });
});
var emailInput = document.getElementById('signupnl-popup-variant');

var expandHandler = function expandHandler(e) {
  if (document.getElementById('popup_expanded_wrapper')) {
    document.getElementById('popup_expanded_wrapper').classList.add('expanded-wrapper-show');
  }

  $('.popup-email--form > p').removeClass('desc-hide');
  $('.btn-signup-small').hide();
  $('.popup-email .input-text').addClass('phone-open');
};

var hideExpandHandler = function hideExpandHandler(e) {
  if (!$(e.target).closest(".popup-email--form").length > 0) {
    $('.popup-email--form > p').addClass('desc-hide');
    $('.btn-signup-small').css({
      'display': 'flex'
    });
    $('.popup-email .input-text').removeClass('phone-open');

    if (document.getElementById('popup_expanded_wrapper')) {
      document.getElementById('popup_expanded_wrapper').classList.remove('expanded-wrapper-show');
    }
  }
};

if (emailInput) {
  emailInput.addEventListener('input', expandHandler);
  emailInput.addEventListener('propertychange', expandHandler);
  emailInput.addEventListener('focus', expandHandler);
  emailInput.addEventListener('focusout', hideExpandHandler);
}

var countrySelect = document.getElementById("popup_select_country");

if (countrySelect) {
  countrySelect.addEventListener("click", function () {
    var options = countrySelect.querySelectorAll("option");
    var count = options.length;

    if (typeof count === "undefined" || count < 2) {
      addActivityItem();
    }
  });
  countrySelect.addEventListener("change", function () {
    addActivityItem();
  });
}

function addActivityItem() {
  var code = countrySelect.querySelector(':checked').getAttribute('data-code');
  document.getElementById('popup_country_code').innerHTML = '+' + code;
}

document.getElementsByTagName('body')[0].addEventListener('click', hideExpandHandler); //exit intent popup

function showExitIntentPopup() {
  console.log('show in');
  document.getElementById('exitIntentPopup').style.visibility = 'visible';
  document.getElementById('exitIntentPopup').style.opacity = 1;
  var startAt = window.nowUtcTime();
  var expiredAt = new Date(new Date().getTime() + parseInt('10') * 60000);
  window.startCountExitIntent(expiredAt, startAt, parseInt('10'));
  setCookie('_exit_intent_counter', 'start', 30);
}

var showIntentPopup = getCookie('_show_eintent_popup');

if (!showIntentPopup) {
  deleteCookie('_exit_intent_counter');
}

var screenWidth = window.innerWidth;

if (document.getElementById('exitIntentPopup') && showIntentPopup !== 'hide' && screenWidth <= 991) {
  var exitIntentTimeout = parseInt(document.getElementById('exitIntentPopup').getAttribute('data-interval')) * 1000;
  setTimeout(function () {
    showExitIntentPopup();
  }, exitIntentTimeout);
}

if (document.getElementById('exitIntentPopup') && screenWidth <= 991 && showIntentPopup !== 'hide') {
  var exitIntentTimeout = parseInt(document.getElementById('exitIntentPopup').getAttribute('data-interval')) * 1000;
  setTimeout(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() <= 0) {
        showExitIntentPopup();
      }
    });
  }, exitIntentTimeout);
}

if (document.getElementById('exitIntentPopup') && showIntentPopup !== 'hide' && screenWidth > 991) {
  var exitIntentTimeout = parseInt(document.getElementById('exitIntentPopup').getAttribute('data-interval-lg')) * 1000;
  setTimeout(function () {
    $(document).mouseleave(function () {
      showExitIntentPopup();
    });
  }, exitIntentTimeout);
}

if ($('.exit-intent-close-trigger').length > 0) {
  $('.exit-intent-close-trigger').on('click', function (e) {
    e.preventDefault();
    clearInterval(intenttimer);
    var screenWidth = window.innerWidth; //close popup action

    $('.exit-intent-popup').removeAttr('style');
    $('.exit-intent-popup').hide();
    var pCode = $('#exit_intent_pcode').val().toLowerCase();

    if ($('.input-discount').val() !== pCode) {
      $('.input-discount').val(pCode);
      $('#promo-code-cta').trigger('click');
      $('.cart-countdown').removeClass('hide-default');
    }

    smCart.checkCode($('#exit_intent_pcode').val().toLowerCase(), function (resp) {
      if (resp.data.can_apply === true && resp.discount_portal == 'shopify') {
        discountSession.setItem('currentDiscount', resp.data.discount.code);
        discountSession.setItem('discountData', JSON.stringify(resp));
        $('.countdown-bar').removeClass('hide-default').show();

        if (screenWidth > 768) {
          $('#header--main-content.fixed').css('top', 48);

          if ($('#header--main-content').hasClass('fixed')) {
            $('.block-notice').addClass('fixed');
          }
        }
      } //todo : set cookie for 30 days


      setCookie('_show_eintent_popup', 'hide', 30);
      utmParams('popup_exit');
      var expiredAt = new Date(new Date().getTime() + parseInt('') * 60000);
      var startAt = window.nowUtcTime();
      setCookie('_counter_expired_at', expiredAt, 30);
      setCookie('_counter_start_at', startAt, 30);
      clearInterval(timer);
      window.startCount(expiredAt, startAt, parseInt(''));
    });
  });
}

window.startCountExitIntent = function (endAt, startAt, counterDuration) {
  if (getCookie('_exit_intent_counter') == 'start') {
    return;
  }

  var start = new Date(window.getUtcTime(startAt));
  var end = new Date(window.getUtcTime(endAt));

  if (counterDuration > 0) {
    end = new Date(new Date().getTime() + counterDuration * 60000);
  }

  var _second = 1000;

  var _minute = _second * 60;

  var _hour = _minute * 60;

  var _day = _hour * 24;

  function showRemaining() {
    var now = new Date();
    var distance = end - now;
    var distanceWhole = end - start;

    if (counterDuration > 0) {
      distanceWhole = counterDuration * 60000;
    }

    if (distance < 0) {
      clearInterval(timer); //document.getElementById('notice-bar-content').innerHTML = 'EXPIRED!';

      $('.distance').css('width', '100%');
      $('.distance-exit-intent-popup').css('width', '100%');
      $('div.mega-menu-type-2').css('top', 48);
      return;
    }

    var days = Math.floor(distance / _day);
    var hours = Math.floor(distance % _day / _hour);
    var minutes = Math.floor(distance % _hour / _minute);
    var seconds = Math.floor(distance % _minute / _second);
    console.log(counterDuration, distance, distanceWhole, end, start);
    $('.numdaysn-exit-intent').html(days);

    if (days > 1) {
      $('.numdaysninfo-exit-intent').html('DAYS');
    } else {
      $('.numdaysninfo-exit-intent').html('DAY');
    }

    $('.numhoursn-exit-intent').html(hours);

    if (hours > 1) {
      $('.numhoursninfo-exit-intent').html('HRS');
    } else {
      $('.numhoursninfo-exit-intent').html('HR');
    }

    $('.numminsn-exit-intent').html(minutes);

    if (minutes > 1) {
      $('.numminsninfo-exit-intent').html('MINS');
    } else {
      $('.numminsninfo-exit-intent').html('MIN');
    }

    $('.numsecsn-exit-intent').html(seconds);

    if (seconds > 1) {
      $('.numsecsninfo-exit-intent').html('SECS');
    } else {
      $('.numsecsninfo-exit-intent').html('SEC');
    }

    var bar_proggress = distance / 1000000000 * 100;

    if (counterDuration > 0) {
      bar_proggress = 100 - distance / distanceWhole * 100;
    } //$('.distance').css('width', `${bar_proggress}%`);


    $('.distance-exit-intent-popup').css({
      'width': "".concat(bar_proggress, "%"),
      'background-color': '#FF6EA9'
    });
  }

  intenttimer = setInterval(showRemaining, 1000);
};